import { render, staticRenderFns } from "./edit1.vue?vue&type=template&id=6fb23634&scoped=true&"
import script from "./edit1.vue?vue&type=script&lang=js&"
export * from "./edit1.vue?vue&type=script&lang=js&"
import style0 from "./edit1.vue?vue&type=style&index=0&id=6fb23634&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb23634",
  null
  
)

export default component.exports